import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";

const MESES = [
  { value: 1, label: "ENERO" },
  { value: 2, label: "FEBRERO" },
  { value: 3, label: "MARZO" },
  { value: 4, label: "ABRIL" },
  { value: 5, label: "MAYO" },
  { value: 6, label: "JUNIO" },
  { value: 7, label: "JULIO" },
  { value: 8, label: "AGOSTO" },
  { value: 9, label: "SEPTIEMBRE" },
  { value: 10, label: "OCTUBRE" },
  { value: 11, label: "NOVIEMBRE" },
  { value: 12, label: "DICIEMBRE" },
];

// Devuelve el número del mes actual (1-12)
const mesActual = () => new Date().getMonth() + 1;

// Convierte 7 → "07"
const pad2 = (n) => String(n).padStart(2, "0");

export default function ModalImprimirComNoDeclarado(props) {
  const op = require("@/modulos/datos");
  const anioActual = new Date().getFullYear();
  const anios = Array.from(new Array(7), (val, index) => anioActual - index);
  const [anio, setAnio] = useState(anioActual);
  const [mesDesde, setMesDesde] = useState(mesActual());
  const [mesHasta, setMesHasta] = useState(mesActual());

  const blanquear = () => {
    setMesDesde(mesActual());
    setMesHasta(mesActual());
  };

  const salir = () => {
    props.setShow();
  };

  const imprimir = () => {
    if (Number(mesDesde) > Number(mesHasta)) {
      alert("El mes 'DESDE' no puede ser mayor que el mes 'HASTA'");
      return;
    }

    const mmDesde = pad2(mesDesde);
    const mmHasta = pad2(mesHasta);
    window.open(
      `${op.reportes}/actividadeconomica?reporte=ListFechDeclNoMes` +
        `&DESDE='${anio}-${mmDesde}-01'` +
        `&HASTA='${anio}-${mmHasta}-31'&TITULO=DESDE EL MES DE ${MESES[mesDesde - 1].label} HASTA EL MES DE ${MESES[mesHasta - 1].label}`,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      onShow={() => {
        blanquear();
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2 text-uppercase">
        <h3 className="fs-4 fw-bold text-light m-0">
          Imprimir Lista de Contribuyentes no Declarados Mensual
        </h3>
        <button className="btn btn-sm bg-light" onClick={() => salir()}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>

      <Modal.Body>
        <div className="d-flex justify-content-between row col-md-12">
          <fieldset className="row col-md-12 border-azul rounded mx-auto d-flex justify-content-between">
            <legend className="float-none w-auto text-uppercase">
              Filtros
            </legend>
            <div className="input-group input-group-sm mb-2 col-md-4">
              <span className="input-group-text text-uppercase">Año:</span>
              <select
                className="form-select form-select-sm"
                value={anio}
                onChange={(e) => setAnio(e.target.value)}
              >
                {anios.map((e, index) => (
                  <option key={index} value={e}>
                    {e}
                  </option>
                ))}
              </select>
            </div>
            {/* DESDE EL MES */}
            <div className="input-group input-group-sm mb-2 col-md-4">
              <span className="input-group-text text-uppercase">
                DESDE EL MES:
              </span>
              <select
                className="form-select form-select-sm"
                value={mesDesde}
                onChange={(e) => setMesDesde(e.target.value)}
              >
                {MESES.map((m) => (
                  <option key={m.value} value={m.value}>
                    {m.label}
                  </option>
                ))}
              </select>
            </div>

            {/* HASTA EL MES */}
            <div className="input-group input-group-sm mb-2 col-md-4">
              <span className="input-group-text text-uppercase">
                HASTA EL MES:
              </span>
              <select
                className="form-select form-select-sm"
                value={mesHasta}
                onChange={(e) => setMesHasta(e.target.value)}
              >
                {MESES.map((m) => (
                  <option key={m.value} value={m.value}>
                    {m.label}
                  </option>
                ))}
              </select>
            </div>
          </fieldset>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button
          className="btn-sm rounded-pill btn btn-primary col-md-2"
          onClick={() => imprimir()}
        >
          <i className="fas fa-print"></i> Imprimir
        </button>
        <button
          onClick={() => salir()}
          className="btn-sm rounded-pill btn btn-danger col-md-2"
        >
          <i className="fa fa-window-close"></i> Salir
        </button>
      </Modal.Footer>
    </Modal>
  );
}
